import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import ROUTES from '../../../utils/routes';
import useProcessPreviewStyles from './quick-overview.styles';
import PRO_TIP_ICON from '../../../assets/pro-tip-document.svg';
import STATIC_TEXT from '../../../content/common.json';
import { PopoverTooltip } from '../../portico/tooltip/tooltip';
import { usePopoverTooltipElementStyles } from '../../portico/tooltip/popover-tooltip.styles';
import { WelcomeBodyWrapper } from '../welcome-body-wrapper';
import { WelcomeFooterWrapper } from '../welcome-footer-wrapper';
import { useEntityState } from '../../../stores/entity/entity.hooks';
import { isUSEntity } from '../../../utils/fenergo-utils';


export const QuickOverview: React.FC = (): JSX.Element => {
  const { process_preview_wrapper } = useProcessPreviewStyles();
  const popoverTooltipElementStyles = usePopoverTooltipElementStyles();
  const navigate = useNavigate();
  const { entityDraft, selectedEntity } = useEntityState();

  const getSubTitle = (): ReactElement => (
    <>
    {isUSEntity(entityDraft)? <>
      {STATIC_TEXT.welcome.processPreview.processDescription1}
      <PopoverTooltip
        messageDescription={STATIC_TEXT.welcome.processPreview.processTooltipDescription}
      >
        <span className={popoverTooltipElementStyles.popoverTooltipElement}>
          {STATIC_TEXT.welcome.processPreview.processDescription2}
        </span>
      </PopoverTooltip>
      {STATIC_TEXT.welcome.processPreview.processDescription3}
    </> : ''}
    </>
  );

  const byCountry = _processStep => !_processStep.isUSOnly || isUSEntity(entityDraft);

  return (
    <>
      <WelcomeBodyWrapper
        activeStep={1}
        totalSteps={3}
        title={STATIC_TEXT.welcome.processPreview.title}
        subTitle={getSubTitle()}
      >
        {/* <div className={process_preview_wrapper}>
          {
            STATIC_TEXT.welcome.processPreview.processSteps
              .filter(byCountry)
              .map((_processStep, _index) => (
                <div key={_index} className="process_preview_lineItem">
                  <div className="line_numbering">{_index + 1}</div>
                  <div className="line_process">
                    <div className="lineTitle">{_processStep.title}</div>
                    <div className="lineDescription">{_processStep.description}</div>
                  </div>
                </div>
              ))
          }
        </div> */}
      </WelcomeBodyWrapper>

      <Divider />

      <WelcomeFooterWrapper
        className="footer__content_process"
        proTipIcon={PRO_TIP_ICON}
        proTipLabel={STATIC_TEXT.welcome.processPreview.proTipLabel}
        proTipDescription={STATIC_TEXT.welcome.processPreview.proTipDescription}
        buttonLabel={STATIC_TEXT.welcome.navigationButton.next_document_prep}
      />
    </>
  );
};